
import { UISharedFolderModel } from '@/store/modules/folders/folders.model'
import { defineComponent } from 'vue'

import formatDate from '../utils/format-date'

export default defineComponent({
  name: 'FoldersList',
  props: {
    folders: {
      type: Array as () => Array<UISharedFolderModel>
    },
    loading: Boolean
  },
  computed: {
    hasFolders(): boolean {
      const len = this.folders?.length || 0
      return len > 0
    }
  },
  methods: {
    formatDate
  }
})
